import axios from "axios";

const baseURL = process.env.REACT_APP_baseURL;
console.log("axios.js", baseURL);

export default axios.create({ baseURL: baseURL });

export const axiosPrivate = axios.create({
    baseURL: baseURL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});
